define("shared/components/shared/ui/validation-messages", ["exports", "@ember/component", "@ember/object", "@ember/service", "@glimmer/component", "@glimmer/tracking", "@ember/template-factory"], function (_exports, _component, _object, _service, _component2, _tracking, _templateFactory) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var _class, _descriptor, _descriptor2;
  0; //eaimeta@70e063a35619d71f0,"ember-cli-htmlbars",0,"@ember/object",0,"@ember/service",0,"@glimmer/component",0,"@glimmer/tracking",0,"@ember/component"eaimeta@70e063a35619d71f
  function _initializerDefineProperty(e, i, r, l) { r && Object.defineProperty(e, i, { enumerable: r.enumerable, configurable: r.configurable, writable: r.writable, value: r.initializer ? r.initializer.call(l) : void 0 }); }
  function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
  function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
  function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
  function _applyDecoratedDescriptor(i, e, r, n, l) { var a = {}; return Object.keys(n).forEach(function (i) { a[i] = n[i]; }), a.enumerable = !!a.enumerable, a.configurable = !!a.configurable, ("value" in a || a.initializer) && (a.writable = !0), a = r.slice().reverse().reduce(function (r, n) { return n(i, e, r) || r; }, a), l && void 0 !== a.initializer && (a.value = a.initializer ? a.initializer.call(l) : void 0, a.initializer = void 0), void 0 === a.initializer ? (Object.defineProperty(i, e, a), null) : a; }
  function _initializerWarningHelper(r, e) { throw Error("Decorating class property failed. Please ensure that transform-class-properties is enabled and runs after the decorators transform."); }
  const __COLOCATED_TEMPLATE__ = (0, _templateFactory.createTemplateFactory)(
  /*
    {{#each @validations as |validation|}}
    <span
      class={{concat this.className " " this.additionalClassName}}
      data-test-id="validation-message"
      data-test-value={{validation.message}}
      {{did-insert (fn this.setAdditionalClassName validation)}}
      ...attributes
    >
      {{html-safe validation.message}}
    </span>
  
    {{#if (and (eq validation.type "media-required") this.displayContentIdeaDraftValidation)}}
      <span class="cPM--field__helperText u--m__t__xs">
        {{t "content_pillars.ideas.media_validation"}}
      </span>
    {{/if}}
  {{/each}}
  */
  {
    "id": "0kGTStry",
    "block": "[[[42,[28,[37,1],[[28,[37,1],[[30,1]],null]],null],null,[[[1,\"  \"],[11,1],[16,0,[28,[37,2],[[30,0,[\"className\"]],\" \",[30,0,[\"additionalClassName\"]]],null]],[24,\"data-test-id\",\"validation-message\"],[16,\"data-test-value\",[30,2,[\"message\"]]],[17,3],[4,[38,3],[[28,[37,4],[[30,0,[\"setAdditionalClassName\"]],[30,2]],null]],null],[12],[1,\"\\n    \"],[1,[28,[35,5],[[30,2,[\"message\"]]],null]],[1,\"\\n  \"],[13],[1,\"\\n\\n\"],[41,[28,[37,7],[[28,[37,8],[[30,2,[\"type\"]],\"media-required\"],null],[30,0,[\"displayContentIdeaDraftValidation\"]]],null],[[[1,\"    \"],[10,1],[14,0,\"cPM--field__helperText u--m__t__xs\"],[12],[1,\"\\n      \"],[1,[28,[35,9],[\"content_pillars.ideas.media_validation\"],null]],[1,\"\\n    \"],[13],[1,\"\\n\"]],[]],null]],[2]],null]],[\"@validations\",\"validation\",\"&attrs\"],false,[\"each\",\"-track-array\",\"concat\",\"did-insert\",\"fn\",\"html-safe\",\"if\",\"and\",\"eq\",\"t\"]]",
    "moduleName": "shared/components/shared/ui/validation-messages.hbs",
    "isStrictMode": false
  });
  let ValidationMessagesComponent = _exports.default = (_class = class ValidationMessagesComponent extends _component2.default {
    constructor() {
      super(...arguments);
      _initializerDefineProperty(this, "router", _descriptor, this);
      _initializerDefineProperty(this, "additionalClassName", _descriptor2, this);
    }
    get className() {
      if (this.args.post.isDraft) {
        return 'cPM--field__helperText';
      }
      if (this.args.type === 'warning') {
        return 'cPM--field__helperText--warning';
      }
      return 'cPM--field__helperText--danger';
    }
    get displayContentIdeaDraftValidation() {
      return this.args.post.isDraft && this.router.currentRoute.queryParams?.contentIdeaId;
    }
    setAdditionalClassName(validation) {
      if (validation?.type === 'media-required') {
        this.additionalClassName = 'qa--textPost_addMedia_errorTxt';
      } else if (validation?.type === 'aspect-ratio') {
        this.additionalClassName = 'qa--postmodal_aspectRatio_error';
      } else if (this.args.type !== 'warning' && this.args.post.isPinterest) {
        if (validation?.attribute === 'album') {
          this.additionalClassName = 'qa--postmodal_pinBoardError';
        } else if (validation?.attribute === 'linkUrl') {
          this.additionalClassName = 'qa--postmodal_clickErrorMsg';
        }
      } else {
        this.additionalClassName = '';
      }
    }
  }, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "router", [_service.inject], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "additionalClassName", [_tracking.tracked], {
    configurable: true,
    enumerable: true,
    writable: true,
    initializer: null
  }), _applyDecoratedDescriptor(_class.prototype, "setAdditionalClassName", [_object.action], Object.getOwnPropertyDescriptor(_class.prototype, "setAdditionalClassName"), _class.prototype)), _class);
  (0, _component.setComponentTemplate)(__COLOCATED_TEMPLATE__, ValidationMessagesComponent);
});